export enum ToggleType {
	Table,
	Chart
}
